export default {"src":"/_next/static/media/barcode.9720e095.svg","height":200,"width":200,"blurWidth":0,"blurHeight":0};